module.exports = __webpack_public_path__ + "static/img/icon-wine@2x.d5412885.png";